import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { IUser } from '../../shared/iUser';

const initialState: IReduxState<IUser> = {
    status: EReduxState.initialState,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        cleanUser: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setUser: (state, action: PayloadAction<IUser>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanUser, setUser } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
